import React from 'react';
import { Auth } from '@leverege/api-redux';
import { connect } from 'react-redux';
import useActivateAccount from "./hooks/useActivateAccount.js";
import PasswordErrorsComponent from "./views/PasswordErrorsComponent.js";
import NewUserForm from "./views/NewUserForm.js";
import ExpiredActivationTokenForm from "./views/ExpiredActivationTokenForm.js";
function ActivateAccount(props) {
  const {
    classNames: {
      className,
      labelClassName,
      submitClassName,
      warningClassName
    },
    components: {
      LoadingComponent,
      LogoComponent,
      ErrorComponent,
      ExpiredActivationCodeInstructionComponent
    },
    variants: {
      variant,
      alreadyRegisteredVariant,
      labelVariant,
      loginLogoVariant,
      passwordVariant,
      warningVariant
    },
    options: {
      getShouldDisplayLogo,
      warningLocation
    },
    state: {
      email,
      error,
      loading,
      phone,
      resendSuccess,
      showResendToken,
      username
    },
    onBackToLogin,
    onSubmit,
    isLoggedIn,
    isLoading,
    passwordValidator
  } = useActivateAccount(props);
  const displayLogo = getShouldDisplayLogo(props, 'login/login');
  if (showResendToken) {
    return /*#__PURE__*/React.createElement(ExpiredActivationTokenForm, {
      className: className,
      displayLogo: displayLogo,
      ErrorComponent: ErrorComponent,
      ExpiredActivationCodeInstructionComponent: ExpiredActivationCodeInstructionComponent,
      isLoading: isLoading,
      isLoggedIn: isLoggedIn,
      loading: loading,
      LoadingComponent: LoadingComponent,
      LogoComponent: LogoComponent,
      onSubmit: onSubmit,
      variant: variant,
      warningLocation: warningLocation,
      resendSuccess: resendSuccess
    });
  }
  return /*#__PURE__*/React.createElement(NewUserForm, {
    alreadyRegisteredVariant: alreadyRegisteredVariant,
    className: className,
    displayLogo: displayLogo,
    email: email,
    error: error,
    ErrorComponent: ErrorComponent,
    isLoading: isLoading,
    isLoggedIn: isLoggedIn,
    labelClassName: labelClassName,
    labelVariant: labelVariant,
    loading: loading,
    LoadingComponent: LoadingComponent,
    loginLogoVariant: loginLogoVariant,
    LogoComponent: LogoComponent,
    onBackToLogin: onBackToLogin,
    onSubmit: onSubmit,
    PasswordErrorsComponent: PasswordErrorsComponent,
    passwordValidator: passwordValidator,
    passwordVariant: passwordVariant,
    phone: phone,
    submitClassName: submitClassName,
    username: username,
    variant: variant,
    warningClassName: warningClassName,
    warningLocation: warningLocation,
    warningVariant: warningVariant
  });
}
export default connect(state => {
  return {
    isLoggedIn: Auth.isLoggedIn(state.auth),
    isLoading: Auth.isLoading(state.auth)
  };
})(ActivateAccount);